import { defineComponent as _defineComponent } from 'vue';
import ScheduleForm from '@/components/ScheduleForm.vue';
import moment from 'moment';
import { ref, watch } from 'vue';
import { useActions, useState } from 'vuex-composition-helpers';
export default /*#__PURE__*/ _defineComponent({
    __name: 'BulkImportDialog',
    props: {
        value: { type: Boolean }
    },
    emits: ["input"],
    setup(__props, { emit }) {
        const props = __props;
        function close() {
            emit('input', false);
        }
        const urls = ref([]);
        const rawText = ref('');
        function parseRawText(text) {
            urls.value.push(...text.split(/[\n|' ']/).filter(line => line));
            rawText.value = '';
        }
        async function parseRawTextFromClipBoard() {
            const clipBoardData = await navigator.clipboard.readText();
            parseRawText(clipBoardData);
        }
        const { isCreatePending: isInProgress } = useState('bulk-import', ['isCreatePending']);
        const { create: enqueueImport } = useActions('bulk-import', ['create']);
        function startEnqueue() {
            enqueueImport({
                urls: urls.value,
                defaultSchedule: {
                    ...schedule.value,
                    timezone: Intl.DateTimeFormat().resolvedOptions().timeZone,
                }
            }).then(() => emit('input', false));
        }
        watch(() => props.value, (shown) => {
            if (shown) {
                urls.value = [];
                rawText.value = '';
            }
        });
        const schedule = ref({
            enabledDateRange: [],
            months: [],
            times: [
                moment().format('HH:mm')
            ],
            weekdays: []
        });
        return { __sfc: true, props, emit, close, urls, rawText, parseRawText, parseRawTextFromClipBoard, isInProgress, enqueueImport, startEnqueue, schedule, ScheduleForm };
    }
});
